export const DateHelpers = () => {
    
    const FormatDateToUTC = (date) => {
        return date.toISOString()
    }
    const FormatToUTCWithoutTimezone = (dateString,withHours) => {
        
        let date = null;
        if(typeof dateString === 'string' && dateString.includes("/")) {
            const [day, month, year] = dateString.split('/');
            date = new Date(`${year}-${month}-${day}`);
        } else {
            date = new Date(dateString);
        }

        // Ottieni componenti UTC
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0'); // mesi 0-based
        const day = String(date.getDate()).padStart(2, '0');        

        // Costruisci la stringa ISO senza "Z"
        return withHours ? `${year}-${month}-${day}T12:00:00` : `${year}-${month}-${day}`;
    }
    const IsDateValid = (date) => {
        const parsedDate = typeof date === "string" ? new Date(date) : date;
        return parsedDate instanceof Date && !isNaN(parsedDate);
    }
    const MonthDiff = (d1, d2) => {
        var months;
        months = (d2.getFullYear() - d1.getFullYear()) * 12;
        months -= d1.getMonth();
        months += d2.getMonth();
        return months;
    }
    const IsSameDate = (d1, d2) => {
        return IsDateValid(d1) && 
            IsDateValid(d2) &&
            d1.getFullYear() === d2.getFullYear() &&
            d1.getMonth() === d2.getMonth() &&
            d1.getDate() === d2.getDate();
    }

    return {
        FormatDateToUTC,
        FormatToUTCWithoutTimezone,
        IsDateValid,
        MonthDiff,
        IsSameDate
    }
}

// Export standalone functions for backward compatibility
export const isDateValid = (date) => {
    const parsedDate = typeof date === "string" ? new Date(date) : date;
    return parsedDate instanceof Date && !isNaN(parsedDate);
}
export const monthDiff = (d1, d2) => {
    var months;
    months = (d2.getFullYear() - d1.getFullYear()) * 12;
    months -= d1.getMonth();
    months += d2.getMonth();
    return months;
}
export const isSameDate = (d1, d2) => {
    return isDateValid(d1) && 
        isDateValid(d2) &&
        d1.getFullYear() === d2.getFullYear() &&
        d1.getMonth() === d2.getMonth() &&
        d1.getDate() === d2.getDate();
}